import React, { ReactNode, useContext, useEffect, useMemo, useRef, useState } from "react";
import cn from "classnames";
import styles from "./badge-select.module.scss";
import { themeContext } from "../../lib";
import { Button } from "../button/button";

export interface IBadgeSelectOption {
    value: string;
    label: string;
}

interface IBadgeSelectProps {
    id?: string;
    value?: string;
    onChange?: (value: string) => void;
    options: IBadgeSelectOption[];
    excludedOptionKeys?: string[];
}

interface IOptionItemProps {
    value: string;
    selected: boolean;
    label: ReactNode;
    onItemClick: (val: string) => void;
}

const OptionItem: React.FC<IOptionItemProps> = ({
                                                    value,
                                                    selected,
                                                    label,
                                                    onItemClick
                                                }) => (
    <div className={selected ? cn(styles.itemSelected, styles.item) : styles.item} onClick={() => onItemClick(value)}>
        {label}
    </div>)

export const BadgeSelect: React.FC<IBadgeSelectProps> = ({
                                                             value,
                                                             onChange,
                                                             id,
                                                             options,
                                                             excludedOptionKeys = [],
                                                         }) => {
    const theme = useContext(themeContext);
    const [menuVisible, setMenuVisible] = useState(false);
    const [menuFocused, setMenuFocused] = useState(false);
    const [selectedOption, setSelectedOption] = useState<string | undefined>(value);
    const label = useMemo(() => {
        if (selectedOption) {
            return options.find(o => o.value === selectedOption)?.label;
        }
    }, [selectedOption, options])


    useEffect(() => {
        setSelectedOption(value);
    }, [value])
    const onButtonClick = () => {
        setMenuVisible((state) => !state);
    }

    const onMenuMouseLeave = () => {
        setMenuFocused(false);
    }

    const onContainerBlur = () => {
        if (!menuFocused) {
            setMenuVisible(false);
        }
    }

    const isItemSelected = (value: string) => {
        return selectedOption === value;
    }

    const onOptionSelectionChange = (value: string) => {
        setSelectedOption(value);
        setMenuVisible(false);
        onChange && onChange(value);
    }

    const optionsContent = <div className={styles.menu}>
        {options.filter(({ value }) => !excludedOptionKeys.includes(value)).map(({ value, label }) => {
            let defaultLabel: ReactNode = label;

            return <OptionItem
                selected={isItemSelected(value)}
                label={defaultLabel}
                value={value}
                key={value}
                onItemClick={(val) => onOptionSelectionChange(val)}
            />
        })}
    </div>;

    return <div className={styles.badgeSelectContainer} id={id} onBlur={() => onContainerBlur()}>
        <Button onClick={onButtonClick}
                view="ghost"
            className={cn(styles.headerText, theme[0] === "light" ? styles.headerBackgroundLight : styles.headerBackgroundDark)}>{label}</Button>
        <div className={menuVisible ? styles.badgeSelectMenuWrapper : styles.badgeSelectMenuWrapperHidden}
             onMouseEnter={() => setMenuFocused(true)}
             onMouseLeave={() => onMenuMouseLeave()}>
            {optionsContent}
        </div>
    </div>;
};
